import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FormProps } from "../../../interfaces/form-action-interfaces";
import { useBrandStore } from "../../brand/states/brand.state";
import { Card, CardBody, CardFooter, CardHeader } from "../../forms/components/card";
import FormsComponent from "../../forms/components/forms.component";
import { useEngineTypeFormStore } from "../states/engine-type.state";

const EngineTypeFormScreen = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const { formParam, setFormParam, forms, setForms, generateForms, onSubmitForm, submitDone, reset, setFormSelectData } = useEngineTypeFormStore();
  const { getBrands, brandsSelectData } = useBrandStore();

  useEffect(() => {
    if (location) {
      setFormParam(location.state as FormProps);
      generateForms(location.state as FormProps);
      getBrands({ page: 0, limit: 100 });
    }
  }, [location]);

  useEffect(() => {
    if (brandsSelectData.length > 0) {
      setFormSelectData(2, brandsSelectData);
    }
  }, [brandsSelectData]);

  useEffect(() => {
    console.log(submitDone);
    if (submitDone) {
      reset();
      navigate(-1)
    }
  }, [submitDone])

  return (
    <form onSubmit={e => {
      e.preventDefault();
      onSubmitForm();
    }}>
      <Card>
        <CardHeader title={`${formParam?.action} ${formParam?.title}`}/>  
        <CardBody>
          <FormsComponent
            forms={forms}
            setForms={setForms}
          />
        </CardBody>
        <CardFooter>
          <button 
            type="submit" 
            className="btn btn-success btn-lg"
            onClick={(e) => {
              e.preventDefault();
              onSubmitForm();
            }}>
              Submit
          </button>
        </CardFooter>
      </Card>  
    </form>
  );
}

export default EngineTypeFormScreen;